module.exports = __webpack_public_path__ + "media/images/lig/uxu-gallery/gallery-item-1-8a71262d39018dbcc169dbc478e07cb2.jpg";